export default "__VITE_ASSET__Kz5jrpa6__"